const hexToRgb = hexStr => {
  let hex = hexStr;
  if (hex.charAt(0) === '#') {
    hex = hex.substr(1);
  }
  if (hex.length < 2 || hex.length > 6) {
    return false;
  }
  const values = hex.split('');
  let red;
  let green;
  let blue;
  if (hex.length === 2) {
    red = parseInt(values[0].toString() + values[1].toString(), 16);
    green = red;
    blue = red;
  } else if (hex.length === 3) {
    red = parseInt(values[0].toString() + values[0].toString(), 16);
    green = parseInt(values[1].toString() + values[1].toString(), 16);
    blue = parseInt(values[2].toString() + values[2].toString(), 16);
  } else if (hex.length === 6) {
    red = parseInt(values[0].toString() + values[1].toString(), 16);
    green = parseInt(values[2].toString() + values[3].toString(), 16);
    blue = parseInt(values[4].toString() + values[5].toString(), 16);
  } else {
    return false;
  }
  return {
    red,
    green,
    blue
  };
};
export default hexToRgb;